import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GagestatsService {
  
  constructor(private _http: HttpClient) { }

  //TODO: add station POST request
  addStation(): void {
  }

  public getNWISInfo(gage) {

    return this._http.get('https://waterservices.usgs.gov/nwis/site?site=' + gage.code, { responseType: 'text'})
    .map(res => {
      var regex = /[+-]?((\d+(\.\d*)?)|(\.\d+))/g;
      try {
        var latLong = res.split(gage.name)[1].match(regex);
        return latLong[0] + ', ' + latLong[1];
      } catch (error) {
        var data = res.split('\n').filter(r => { return (!r.startsWith("#") && r != "") })[2].split('\t');
        return data[4] + ', ' + data[5];
      }
    })
  }

  private formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  }

  public getNWISPeriodOfRecord(gage){
    if(!gage.code) return;
    return this._http.get('https://waterservices.usgs.gov/nwis/site?seriesCatalogOutput=true&outputDataTypeCd=dv&format=rdb&site=' + gage.code, { responseType: 'text'})
    .map(res => {
      
      // Filter waterservices page
      const lines = res.split ('\n');
      const dataLines = lines.filter(line => !line.startsWith('#') && line.trim() !== '');

      // Extract header
      const headers = dataLines[0].split('\t');

      // Find the index of the columns we are interested in
      const parmCdIndex = headers.indexOf('parm_cd');
      const beginDateIndex = headers.indexOf('begin_date');
      const endDateIndex = headers.indexOf('end_date');

      // Process the data rows
      const results: { begin_date: string, end_date: string }[] = lines.slice(6) // Start after the headers and format description
        .filter(line => !line.startsWith('#')) // Exclude comment lines
        .map(line => line.split('\t'))
        .filter(columns => columns[parmCdIndex] === '00060') // Filter by parm_cd = '00060'
        .map(columns => ({
          begin_date: columns[beginDateIndex],
          end_date: columns[endDateIndex],
      }));
      
      // Establish start and end dates
      const beginDates = results.map(result => new Date(result.begin_date).getTime());
      const endDates = results.map(result => new Date(result.end_date).getTime());

      // Conditional statements that return date range based on results
      var formattedEarliestDate = "N/A"
      var formattedMostRecentDate = "N/A"
      // Condition for when the start date is defined
      if (beginDates.length !== 0){
        const earliestBeginDate = new Date(Math.min(...beginDates));
        formattedEarliestDate = this.formatDate(earliestBeginDate.toISOString().split('T')[0]);
      }
      // Condition for when the end date is defined
      if (endDates.length !== 0){ 
      const mostRecentEndDate = new Date(Math.max(...endDates));
      formattedMostRecentDate = this.formatDate(mostRecentEndDate.toISOString().split('T')[0]);
      }
      // Condition for when both start and end dates are not defined
      if (beginDates.length === 0 && endDates.length === 0){
        return "N/A";
      }
      return formattedEarliestDate.toString() + ' - ' + formattedMostRecentDate.toString()
    });
  }
}
